import { useState } from 'react'
import ValidationCarousel from './ValidationCarousel'
import WaitlistForm from './WaitlistForm'
import NoFeedbackForm from './NoFeedbackForm'
import ThankYouScreen from './ThankYouScreen'
import type { Slide } from './slideData'

type ViewState = 'carousel' | 'waitlist' | 'no-feedback' | 'thankyou'

export default function PublicValidation() {
  const [view, setView] = useState<ViewState>('carousel')
  const [activeSlide, setActiveSlide] = useState<Slide | null>(null)

  function handleYes(slide: Slide) {
    setActiveSlide(slide)
    setView('waitlist')
  }

  function handleNo(slide: Slide) {
    setActiveSlide(slide)
    setView('no-feedback')
  }

  function handleWaitlistDone() {
    setView('thankyou')
  }

  function handleNoFeedbackDone() {
    setView('carousel')
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      {view === 'carousel' && (
        <ValidationCarousel onYes={handleYes} onNo={handleNo} />
      )}
      {view === 'waitlist' && (
        <WaitlistForm slide={activeSlide} onDone={handleWaitlistDone} />
      )}
      {view === 'no-feedback' && (
        <NoFeedbackForm slide={activeSlide} onDone={handleNoFeedbackDone} />
      )}
      {view === 'thankyou' && <ThankYouScreen />}
    </div>
  )
}
